"use client"

import { useState } from "react"
import { Link } from "react-router-dom"
import {
    Box,
    Typography,
    TextField,
    Button,
    Paper,
    MenuItem,
    Select,
    FormControl,
    InputLabel,
    FormHelperText,
    Container,
    createTheme,
    ThemeProvider,
} from "@mui/material"
import logo from "../../assets/images/logo.jpeg"
import axios from "axios"
import MainLayouts from "../../layout/MainLayouts"
import { ArrowBack } from "@mui/icons-material"




const theme = createTheme({
    components: {
        MuiOutlinedInput: {
            styleOverrides: {
                notchedOutline:{
                    borderColor: "#d15242"
                },
                root:{
                    '&:hover .MuiOutlinedInput-notchedOutline':{
                        borderColor: "#d15242"
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: "#d15242"
                    }
                }
            },
        },
    },
})
export default function ConsultForm() {
    const [formData, setFormData] = useState({
        company_name: "",
        email: "",
        // user_message: "",
        full_name: "",
        phone_number: "",
        roles_hiring_for: "",
        employment_type: "",
        location_preference: [],
        expected_start_date: "",
        job_description: "",
        industry: "",
        company_website: "",
    })

    const [errors, setErrors] = useState({
        company_name: false,
        email: false,
        // user_message: false,
        full_name: false,
        roles_hiring_for: false,
        employment_type: false,
        location_preference: false,
        expected_start_date: false,
        job_description: false,
        industry: false,
    })

    const [, setFormSubmitted] = useState(false)
    const [errorMessage, setErrorMessage] = useState("")
    const [isSubmitting, setIsSubmitting] = useState(false)
   

    const handleChange = (e) => {
        const { name, value } = e.target
        setFormData(prev => ({
            ...prev,
            [name]: value,
        }))

        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: false,
            }))
        }
    }

    const validateForm = () => {
        const newErrors = {
            company_name: !formData.company_name,
            email: !formData.email || !/\S+@\S+\.\S+/.test(formData.email),
            // user_message: !formData.user_message,
            full_name: !formData.full_name,
            roles_hiring_for: !formData.roles_hiring_for,
            employment_type: !formData.employment_type,
            location_preference: formData.location_preference.length === 0,
            expected_start_date: !formData.expected_start_date,
            job_description: !formData.job_description,
            industry: !formData.industry,
        }

        setErrors(newErrors)
        return !Object.values(newErrors).some(Boolean)
    }

    const navigateToConfirmation = () => {
        window.location.href = "/consultancy/confirmation"
    }
    const handleSubmit = async (e) => {
        e.preventDefault()
        const isValid = validateForm()

        if (!isValid) {
            const firstErrorField = Object.keys(errors).find(key => errors[key])
            if (firstErrorField) {
                document.getElementsByName(firstErrorField)[0]?.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                })
            }
            return
        }

        setFormSubmitted(true)
        setIsSubmitting(true)
        setErrorMessage("")

        try {
            console.log("Submitting form data:", formData)
            const response = await axios.post(
                "https://e1xaca.edoubleone.net/api/consultancy",
                formData,
                {
                    headers: { "Content-Type": "application/json" },
                }
            )
            console.log("Response received:", response)

            if (response.status === 201 || response.data?.success) {
                navigateToConfirmation()
            } else {
                setErrorMessage(response.data?.message || "Submission failed. Please try again.")
            }
        } catch (error) {
            console.error("Error submitting form:", error)
            setErrorMessage(
                error.response?.data?.message ||
                "Something went wrong while submitting the form. Please try again."
            )
        } finally {
            setIsSubmitting(false)
        }
    }

    const isFormComplete = () => {
        return (
            formData.company_name &&
            formData.email &&
            formData.full_name &&
            formData.job_description &&
            formData.employment_type &&
            formData.location_preference.length > 0 &&
            formData.expected_start_date &&
            formData.roles_hiring_for &&
            formData.industry
        )
    }

    const lookingFor = [
        "Data Analyst",
        "Artificial Intelligent Expert",
        "Machine Learning",
        "Digital Marketing Specialist",
        "Others"
    ]

    const employmentType = [
        "Full-time",
        "Part-time",
        "Contract",
        "Internship"
    ]

    const locationPreference = [
        "Remote",
        "Onsite",
        "Hybrid"
    ]

    return (
        <MainLayouts>
        <ThemeProvider theme={theme}>
        <Container maxWidth="md" sx={{ py: { xs: 3, sm: 4, md: 6 }, px: { xs: 2, sm: 3, md: 4 } }}>
                    
                {/* <Box sx={{ display: "flex", alignItems: "start", mt: 4 , }} >
                    <Link to={"/talents"}>
                        <ArrowBack sx={{"&:hover": { backgroundColor: "#E84A1C", color: "#ffffff"} }} />
                    </Link>
            </Box> */}
            <Link to={"/talents"}>
                        <Box sx={{ display: "flex", alignItems: "start", flexDirection: "row", color: "black", mt: 4,}} >
                              <ArrowBack sx={{ mr: 1, }} />
                              <Typography>Back</Typography>
                            </Box>
                          </Link>
            <Paper
                elevation={0}
                sx={{
                    width: "100%",
                    maxWidth: "600px",
                    mx: "auto",
                    p: { xs: 2, sm: 3, md: 4 },
                    borderRadius: 2,
                }}
            >
            
                <Box
                    sx={{

                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                    }}
                >
                    <Box sx={{ mb: 4, width: "100%", maxWidth: 100, mx: 0 }}>
                        <Link to={"/"}>
                        <img
                            src={logo}
                            alt="E1X Academy Logo"
                            width={100}
                            height={50}
                            style={{ objectFit: "contain" }}
                        />
                        </Link>
                    </Box>

                    <Typography
                        component="h1"
                        variant="h4"
                        fontWeight="bold"
                        sx={{ fontFamily: "Monserrat, sans-serif", mb: 1, fontSize: { xs: "1.5rem", sm: "2rem", md: "2.125rem" } }}
                    >
                            Thank you for your interest in E1X Talent Matching
                    </Typography>

                    <Typography variant="body1" color="text.secondary" sx={{ fontFamily: "Monserrat, sans-serif", mb: 4 }}>
                        Let’s help you find the right talent for your team. Fill out the form below so we can understand your hiring goals and match you with top E1X-trained professionals.
                    </Typography>

                    <Box component="form" noValidate onSubmit={handleSubmit} sx={{ width: "100%" }}>
                        <Typography variant="body1" sx={{ mb: 2, color: "#000000", fontWeight: "bold", fontFamily: "Monserrat, sans-serif", fontSize: "20px" }}> Company Information</Typography>
                        <Typography variant="body1" sx={{ mb: 1, color: "#000000", fontWeight: "bold", fontFamily: "Monserrat, sans-serif" }}> Company Name</Typography>
                        <TextField

                            placeholder="Enter Your Organisation's Name"
                            fullWidth
                            name="company_name"
                            value={formData.company_name}
                            onChange={handleChange}
                            required
                            sx={{ mb: 3 }}
                            error={errors.company_name}
                            helperText={errors.company_name ? "Company Name is required" : ""}
                        />
                        <Typography variant="body1" sx={{ mb: 1, color: "#000000", fontWeight: "bold", fontFamily: "Monserrat, sans-serif" }}> Industry</Typography>
                        <TextField

                            placeholder="Select the industry you operate in"
                            fullWidth
                            name="industry"
                            value={formData.industry}
                            onChange={handleChange}
                            required
                            sx={{ mb: 3 }}
                            error={errors.industry}
                            helperText={errors.industry ? "Industry is required" : ""}
                        />

                        <Typography variant="body1" sx={{ mb: 1, color: "#000000", fontWeight: "bold", fontFamily: "Monserrat, sans-serif" }}> Company Website</Typography>
                        <TextField

                            placeholder="Optional- helps us learn more about you"
                            fullWidth
                            name="company_website"
                            value={formData.company_website}
                            onChange={handleChange}
                            sx={{ mb: 3 }}

                        />
                        <Typography variant="body1" sx={{ mb: 2, color: "#000000", fontWeight: "bold", fontFamily: "Monserrat, sans-serif", fontSize: "20px" }}> Talent Requirement </Typography>
                        <Typography variant="body1" sx={{ mb: 1, color: "#000000", fontWeight: "bold", fontFamily: "Monserrat, sans-serif" }}> Role Hiring</Typography>
                        <FormControl fullWidth required sx={{ mb: 3 }} error={errors.roles_hiring_for}>
                            <InputLabel id="roles_hiring-for-label">Choose an Option</InputLabel>
                            <Select
                                labelId="roles_hiring-for-label"
                                id="roles_hiring_for"
                                name="roles_hiring_for"
                                value={formData.roles_hiring_for}
                                label="Choose Option"
                                onChange={handleChange}
                            >
                                {lookingFor.map((looking) => (
                                    <MenuItem key={looking} value={looking} sx={{ backgroundColor: "#ffffff", "&:hover": { backgroundColor: "#E84A1C", color: "#ffffff" } }}>
                                        {looking}
                                    </MenuItem>
                                ))}
                            </Select>
                            {errors.roles_hiring_for && <FormHelperText>Roles hiring is required</FormHelperText>}
                        </FormControl>
                        <Typography variant="body1" sx={{ mb: 1, color: "#000000", fontWeight: "bold", fontFamily: "Monserrat, sans-serif" }}> Location Preferece</Typography>
                        <FormControl fullWidth required sx={{ mb: 3 }} error={Array.isArray(errors.location_preference) ? errors.location_preference[0] : errors.location_preference}>
                            <InputLabel id="location_preference">Choose an Option</InputLabel>
                            <Select
                                labelId="location_preference"
                                id="location_preference"
                                name="location_preference"
                                value={formData.location_preference}
                                label="Choose Option"
                                onChange={(e) => {
                                    const { value } = e.target;
                                    setFormData(prev => ({
                                        ...prev,
                                        location_preference: typeof value === 'string' ? value.split(',') : value,
                                    }));
                                }}
                                renderValue={(selected) => selected.join(', ')}
                                multiple
                            >
                                {locationPreference.map((location) => (
                                    <MenuItem key={location} value={location} sx={{ backgroundColor: "#ffffff", "&:hover": { backgroundColor: "#E84A1C", color: "#ffffff" } }}>
                                        {location}
                                    </MenuItem>
                                ))}
                            </Select>
                            {errors.location_preference && <FormHelperText>Location is required</FormHelperText>}
                        </FormControl>
                        <Typography variant="body1" sx={{ mb: 1, color: "#000000", fontWeight: "bold", fontFamily: "Monserrat, sans-serif" }}> Employment Type</Typography>
                        <FormControl fullWidth required sx={{ mb: 3 }} error={errors.employment_type}>
                            <InputLabel id="employment_type">Choose an Option</InputLabel>
                            <Select
                                labelId="employment_type"
                                id="employment_type"
                                name="employment_type"
                                value={formData.employment_type}
                                label="Choose Option"
                                onChange={handleChange}
                            >
                                {employmentType.map((employment) => (
                                    <MenuItem key={employment} value={employment} sx={{ backgroundColor: "#ffffff", "&:hover": { backgroundColor: "#E84A1C", color: "#ffffff" } }}>
                                        {employment}
                                    </MenuItem>
                                ))}
                            </Select>
                            {errors.employment_type && <FormHelperText>Employment Type is required</FormHelperText>}
                        </FormControl>

                        <Typography variant="body1" sx={{ mb: 1, color: "#000000", fontWeight: "bold", fontFamily: "Monserrat, sans-serif" }}> Expected Start Date</Typography>

                        <TextField
                            placeholder="yyyy-mm-dd"
                            fullWidth
                            name="expected_start_date"
                            type="text"
                            value={formData.expected_start_date}
                            onChange={handleChange}
                            required
                            sx={{ mb: 3 }}
                            error={errors.expected_start_date}
                            helperText={errors.expected_start_date ? "Expected Start Date is required" : ""}
                        />

                        <Typography variant="body1" sx={{ mb: 1, color: "#000000", fontWeight: "bold", fontFamily: "Monserrat, sans-serif" }}>
                            Brief Job Description
                        </Typography>

                        <TextField
                            placeholder=" What should this talent be able to do? Add any specific tools, skills, or responsibilities."
                            fullWidth
                            name="job_description"
                            value={formData.job_description}
                            onChange={handleChange}
                            multiline
                            rows={4}
                            sx={{ mb: 3 }}
                        />

                        <Typography variant="body1" sx={{ mb: 2, color: "#000000", fontWeight: "bold", fontFamily: "Monserrat, sans-serif", fontSize: "20px" }}> Contact Information</Typography>
                        <Typography variant="body1" sx={{ mb: 1, color: "#000000", fontWeight: "bold", fontFamily: "Monserrat, sans-serif" }}> Full Name</Typography>

                        <TextField
                            placeholder="Enter Your Name"
                            fullWidth
                            name="full_name"
                            type="full_name"
                            value={formData.full_name}
                            onChange={handleChange}
                            required
                            sx={{ mb: 3 }}
                            error={errors.full_name}
                            helperText={errors.full_name ? "Full Name is required" : ""}
                        />
                        <Typography variant="body1" sx={{ mb: 1, color: "#000000", fontWeight: "bold", fontFamily: "Monserrat, sans-serif" }}>Email Address</Typography>

                        <TextField
                            placeholder="Enter Your Email Address"
                            fullWidth
                            name="email"
                            type="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                            sx={{ mb: 3 }}
                            error={errors.email}
                            helperText={errors.email ? "Valid email is required" : ""}
                        />

                        <Typography variant="body1" sx={{ mb: 1, color: "#000000", fontWeight: "bold", fontFamily: "Monserrat, sans-serif" }}> Phone Number</Typography>

                        <TextField
                            placeholder=" Optional – for faster communication"
                            fullWidth
                            name="phone_number"
                            value={formData.phone_number}
                            onChange={handleChange}
                            sx={{ mb: 3 }}
                        />


                        {errorMessage && (
                            <div style={{ color: "red", marginBottom: "10px" }}>
                                {errorMessage}
                            </div>
                        )}
                    </Box>
                </Box>

                <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                <Button
                    type="submit"
                    variant="contained"
                    onClick={handleSubmit}
                    sx={{
                        py: 1,
                        px: 3,
                        backgroundColor: "#333333",
                        "&:hover": { backgroundColor: "#222222" },
                    }}
                    disabled={!isFormComplete() || isSubmitting}
                >
                    {isSubmitting ? "Sending..." : "Send Message"}
                </Button>
                </Box>


                
            </Paper>
        </Container>
        </ThemeProvider>
        </MainLayouts>
    )
}